import currency from 'currency.js';
import { NumericString } from './typescript';

export const amountToUsd = (amount?: number | NumericString) => amount ? currency(amount).format() : null;

export const amountToKhr = (amount?: number | NumericString) =>
  amount ? currency(amount, { pattern: '# ៛', precision: 0 }).format() : null;
